import React from "react";
import { reloadOnce, isAssetError } from "@/lib/autoReload";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error?.message, "\n", error?.stack, errorInfo?.componentStack);
    if (isAssetError(error)) reloadOnce();
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "#FAEEE7",
            fontFamily: "Manrope, sans-serif",
          }}
        >
          <div style={{ maxWidth: 420, textAlign: "center" }}>
            <h1 style={{ fontSize: 28, fontWeight: 900, color: "#E53935", margin: 0 }}>
              Ops! Algo deu errado.
            </h1>
            <p style={{ color: "#555", marginTop: 12, lineHeight: 1.6 }}>
              Tivemos um problema inesperado ao carregar esta página. Tente novamente.
            </p>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              style={{
                marginTop: 20,
                padding: "12px 24px",
                borderRadius: 9999,
                border: "none",
                background: "#E53935",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
